
<template>
  <div class="invoice-form">
    <Form ref="invoiceForm" class="form-wrap" :model="model">
      <FormGroup legend="发票类型" class="invoice-form-group">
        <div class="invoice-types">
          <div v-if="currentInvoiceType === 'electronic'" class="btn selected">
            普通电子发票
          </div>
          <div v-else class="btn default">纸质发票</div>
        </div>
        <!-- <Radios  v-if="currentInvoiceType !=='electronic'"/> -->
      </FormGroup>

      <FormGroup legend="发票详情" class="invoice-form-group">
        <FormItem
          :field="{
            label: '发票抬头',
            labelStyle: { position: 'relative', top: '-3px' },
          }"
        >
          <Radios
            v-model="model.title_type"
            :radios.sync="titleTypeOptions"
            class="invoice-detail-radios"
            @change="changeTitleType"
          />
        </FormItem>

        <!--个人-->
        <template v-if="model.title_type !== 'enterprise'">
          <FormItem
            :field="{ label: '个人姓名' }"
            prop="title_name"
            :rules="limtLengthRules"
          >
            <InputItem
              key="personel"
              v-model="model.title_name"
              v-bind="{ placeholder: ' ' }"
            />
          </FormItem>
        </template>

        <!--公司-->
        <template v-else>
          <FormItem
            :field="{ label: '抬头名称' }"
            prop="title_name"
            :rules="limtLengthRules"
          >
            <InputItem
              key="enterprise"
              :value="model.title_name"
              v-bind="{ placeholder: ' ' }"
              @input="handleTitleName"
              @blur="(e) => handleBlur(e, 'title_name')"
            />
            <SelectItem
              v-if="companyNameOptions.length && isShowSelect"
              style="top: 40px"
              :options="companyNameOptions"
              @change="changeCompanyName"
            >
            </SelectItem>
          </FormItem>

          <FormItem
            :field="{ label: '税号' }"
            :rules="taxCodeRules"
            prop="tax_code"
          >
            <InputItem
              key="enterprise"
              v-model="model.tax_code"
              v-bind="{ placeholder: ' ' }"
            />
          </FormItem>

          <FormItem :field="{ label: '更多信息' }" @click="open = true">
            <div class="input-wrap">
              <InputItem
                key="enterprise"
                v-bind="{
                  placeholder: ' 填写地址、电话等（非必填）',
                  disabled: true,
                }"
                :value="getMoreInfoText()"
              />
              <img class="icon" src="./Form/assets/right-arrow.svg" />
            </div>
            <slot name="moreInfoSheet">
              <Sheet
                v-model="moreInfo"
                :open.sync="open"
                @changeMoreInfo="changeMoreInfo"
              />
            </slot>
          </FormItem>
        </template>
      </FormGroup>

      <FormGroup legend="收件信息" class="invoice-form-group">
        <!--公司或个人纸质发票-->
        <!-- <template v-if="currentInvoiceType !== 'electronic'">
                  <FormItem :field="receiveInfofields[1]">

                  </FormItem>
                  <FormItem :field="receiveInfofields[2]">

                  </FormItem>
                  <FormItem :field="receiveInfofields[3]">
                      
                  </FormItem>
                  <FormItem :field="receiveInfofields[4]">

                  </FormItem>
                  <div class="tip">
                    <img class="tip-icon"><span class="tip-content">开具纸质发票默认申通到付</span>
                  </div>
                </template> -->

        <!--公司或个人电子发票-->
        <FormItem :field="{ label: '邮箱' }" :rules="emailRules" prop="email">
          <InputItem
            v-model="model.email"
            v-bind="{ placeholder: '请填写用于接收电子发票的邮箱地址' }"
          />
        </FormItem>
      </FormGroup>

      <FormGroup
        v-if="
          currentInvoiceType === 'electronic' &&
          invoiceDetailData.pageType !== 'modify'
        "
        class="invoice-form-group"
      >
        <header class="title">
          <span>——</span> <span class="text"> 开票须知 </span> <span>——</span>
        </header>
        <div
          class="content-detail"
          v-html="invoiceDetailData.please_read"
        ></div>
      </FormGroup>
    </Form>

    <div ref="footer" class="footer">
      <slot name="footer">
        <div v-if="invoiceDetailData.pageType === 'apply'" class="button-wrap">
          <ApplyButton
            :active="active"
            :disabled="disabled"
            @click="submitHandler"
          >
            申请开票
          </ApplyButton>
        </div>
        <div
          v-if="invoiceDetailData.pageType !== 'apply'"
          class="modify-button"
        >
          <div class="btn border" @click="cancleModify">取消</div>

          <div
            class="btn"
            :class="disabled ? 'disabled' : 'primary'"
            @click="confirmModify"
          >
            确定
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/no-magic-numbers */

import { Vue, Prop, Component, Watch, Inject } from 'vue-property-decorator';
import Radios from './Radios/Radios.vue';
import ApplyButton from './Button/button.vue';
import Form from './Form/Form.vue';
import FormGroup from './Form/FormGroup.vue';
import FormItem from './Form/FormItem.vue';
import InputItem from './Input/ForchangeInput.vue';
import SelectItem from './Select/select.vue';
import Sheet from './Sheets/Sheet.vue';
import { debounce } from '@lib/util';
import { BottomSheet } from 'muse-ui';
Vue.use(BottomSheet);
import 'muse-ui/dist/muse-ui.css';

@Component({
  components: {
    Radios,
    ApplyButton,
    Form,
    FormGroup,
    FormItem,
    InputItem,
    SelectItem,
    Sheet,
  },
  data() {
    return {};
  },
})
export default class InvoiceFillForm extends Vue {
  @Prop({ type: Function })
  getCompanyOptions!: any;
  @Prop({ type: Function })
  getTaxCode!: any;
  @Prop({ type: Object })
  invoiceDetailData!: {
    pageType?: string;
  };
  @Prop({ type: Object })
  modelData!: {};
  @Prop({ type: Object })
  moreInfoData!: {};

  model: any = {};

  active: Boolean = false;
  open: Boolean = false;
  disabled: Boolean = true;
  limtLengthRules: Array<any> = [
    { validate: this.limitLength, message: '请输入2-50个字' },
  ];
  taxCodeRules: Array<any> = [
    { validate: this.checkTaxId, message: '税号格式错误,请重新输入' },
    {
      validate: this.checkTitleType,
      message: '税号格式错误,请重新输入',
    },
  ];
  emailRules: Array<any> = [
    { validate: this.checkEmail, message: '邮箱格式错误,请重新输入' },
  ];

  titleNameRules: Array<any> = [{ validate: (val: any) => !!val, message: '' }];
  titleTypeOptions: Array<any> = [
    {
      label: '公司',
      value: true,
      key: 'enterprise',
    },
    {
      label: '个人',
      value: false,
      key: 'personal',
    },
  ];

  formData: any = {
    electronic: {
      enterprise: {
        title_type: 'enterprise',
        invoice_type: 'electronic',
        title_name: '',
        tax_code: '',
        email: '',
      },
      personal: {
        title_type: 'personal',
        invoice_type: 'electronic',
        title_name: '',
        email: '',
      },
    },
    // 'paper': {
    //     'enterprise': {
    //       title_name: '',
    //       tax_code: '',
    //       paper_type: '',
    //       Recipient: '',
    //       phone: '',
    //       area: '',
    //       location: ''
    //     },
    //     'personal': {
    //       title_name: '',
    //       paper_type: '',
    //       Recipient: '',
    //       phone: '',
    //       area: '',
    //       location: ''
    //     }
    // },
  };

  currentInvoiceType = 'electronic';
  moreInfo: any = {};
  isConfirmed = false;

  @Watch('moreInfo', { deep: true })
  onMoreInfoChanged(newValue: any, oldValue: any) {}

  @Watch('moreInfoData')
  onMoreInfoData(newValue: any, oldValue: any) {
    if (this.isConfirmed) {
      this.isComfirmed = false;
      return;
    }
    this.moreInfo = { ...newValue };
  }

  // 确认之后才真正的保存数据到本地
  changeMoreInfo(moreInfo: any) {
    this.isConfirmed = true;
    this.$emit('changeMoreInfo', { ...moreInfo });
  }

  @Watch('modelData')
  onModelData(newValue: any, oldValue: any) {
    this.model = newValue || {}; // 初始化
  }

  @Watch('model', { deep: true })
  onModelChanged(newValue: any, oldValue: any) {
    const keys = Object.keys(newValue);
    const result = keys.some((key, index) => {
      return !newValue[key];
    });
    if (result) {
      this.active = false;
      this.disabled = true;
    } else {
      this.active = true;
      this.disabled = false;
    }
    this.$emit('changeModel', newValue);
  }

  async mounted() {
    document.body.addEventListener('focusout', this.handlerScrollTop);
  }

  beforeDestroy() {
    document.body.removeEventListener('focusout', this.handlerScrollTop);
  }

  getMoreInfoText() {
    const keys: Array<string> = Object.keys(this.moreInfo);
    let count = 0;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < keys.length; i++) {
      if (this.moreInfo[keys[i]]) {
        count++;
      }
    }
    return count ? `共${keys.length}项， 已填${count}项` : '';
  }

  closeBottomSheet() {
    this.open = false;
  }

  openBotttomSheet() {
    this.open = true;
  }

  // ios软键盘收起的事件处理
  handlerScrollTop(e: any) {
    if (window.navigator['userAgent'].indexOf('iPhone') > -1) {
      // eslint-disable-next-line no-self-assign
      document.body['scrollTop'] = document.body.scrollTop; // ?
    }
  }

  handleBlur(e: any, key: any) {
    this.isShowSelect = false;
  }

  changeHander(e: any, key: any) {
    const value = e.target && e.target.value;
    this.model[key] = value;
  }

  handleTitleName(value: any) {
    this.model['title_name'] = value;
    if (value) {
      this.isShowSelect = true;
      if (this.intervalId) {
        clearTimeout(this.intervalId);
      }
      this.intervalId = setTimeout(() => {
        this.getCompanyNameOptions(value);
      }, 800);
    } else {
      this.isShowSelect = false;
    }
  }

  handleInput(value: any, key: any) {
    this.model[key] = value;
  }

  companyNameOptions: any = [];
  intervalId: any = null;
  isShowSelect = false;
  async getCompanyNameOptions(value: any) {
    const result = await this.getCompanyOptions(value);
    this.companyNameOptions = result;
  }

  async changeCompanyName(companyNameOptionsItem: any) {
    this.isShowSelect = false;
    this.model['title_name'] = companyNameOptionsItem.name;
    const result = await this.getTaxCode(companyNameOptionsItem.id);
    this.model.tax_code = result;
  }

  addMoreInfo() {
    return {
      bank_name: '',
      bank_account: '',
      organization_address: '',
      organization_tel: '',
    };
  }

  changeForm(currentTitleType: any) {
    let model = this.model;
    model = this.formData[model.invoice_type][model.title_type];
    if (model.title_type === 'enterprise') {
      this.moreInfo = this.addMoreInfo();
    }
    model.email = this.model.email;
    this.model = { ...model };
  }

  changeTitleType(radio: any, radios: any) {
    this.changeForm(radio && radio.key);
  }

  limitLength(e: any, maxLength = 100, minLength = 4) {
    const value = e;
    const values = value.split('');
    const valuesLengths = values.map((s: number, i: number) => {
      return value.charCodeAt(i) >= 0 && value.charCodeAt(i) <= 128 ? 1 : 2;
    });
    let n = 0;
    const charLength =
      valuesLengths.length > 0 &&
      valuesLengths.reduce(
        (accumulator: number, currentValue: number, index: number) => {
          const count: number = accumulator + currentValue;
          if (count === 31 || count === 32) {
            n = index;
          }
          if (count > maxLength) {
            this.model.title_name = values.slice(0, n + 1).join('');
          }
          return count;
        }
      );

    if (charLength > 100 || charLength < 4) return false;
    else return true;
  }
  checkTitleType() {
    return this.model.title_type === 'enterprise';
  }

  checkTaxId(taxId: any) {
    const regArr: any = [
      /^[0123456789QWERTYUPADFGHJKLXCBNM]{15}$/,
      /^[0123456789QWERTYUPADFGHJKLXCBNM]{17}$/,
      /^[0123456789QWERTYUPADFGHJKLXCBNM]{18}$/,
      /^[0123456789QWERTYUPADFGHJKLXCBNM]{20}$/,
    ];
    let i;
    const j = regArr.length;

    for (i = 0; i < j; i++) {
      if (regArr[i].test(taxId)) {
        return true;
      }
    }
    return false;
  }

  checkEmail(value: any) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (value.indexOf(' ') > -1) return false;
    const mailReg =
      /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
    // const mailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    return mailReg.test(value);
  }

  isRightRaxCode = true;
  submitHandler(currentFilledFormData: any) {
    this.$refs.invoiceForm.validate().then((result: any) => {
      if (result) {
        this.$emit('confirm', this.model, this.moreInfo);
      }
    });
  }

  confirmModify() {
    if (this.disabled) {
      return;
    }
    this.$refs.invoiceForm.validate().then((result: any) => {
      if (result) {
        this.$emit('confirmModify', this.model, this.moreInfo);
      }
    });
  }

  cancleModify(value: any) {
    this.$emit('cancleModify', value);
  }

  resetHandler() {}

  clear() {
    this.$refs.invoiceForm.clear();
  }
}
</script>

<style lang="scss" scoped>
.form-wrap {
  padding: 30px 30px 0 30px;
}

.invoice-types {
  display: flex;
  padding: 0 40px 32px;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    padding: 10px 20px;
    color: #6749ec;
    font-weight: normal;
    font-size: 28px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    border-radius: 100px;
    cursor: pointer;
    &.selected {
      color: #6749ec;
      border: solid 2px #6749ec;
    }

    &.default {
      color: #8f8c8c;
      border: solid 2px #888585;
    }

    &:active {
      opacity: 0.7;
    }

    & + .btn {
      margin-left: 24px;
    }
  }
}

.modify-button {
  display: flex;
  padding: 11px 0;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 336px;
    height: 96.4px;
    font-weight: normal;
    font-size: 28px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    border-radius: 49px;
    cursor: pointer;
    &.border {
      color: #6749ec;
      border: solid 2px #6749ec;
    }
    &.primary {
      color: #fff;
      background: #6749ec;
    }
    &.disabled {
      color: #fff;
      background-color: #dbdada;
    }

    &:active {
      opacity: 0.7;
    }

    & + .btn {
      margin-left: 14px;
    }
  }
}

.invoice-detail-radios {
  margin-left: 56px;
}

.invoice-form-group {
  header {
    padding: 32px;
    color: #383333;
    text-align: center;
    &.title {
      // display: flex;
    }
    .text {
      margin: 0 24px;
      color: #383333;
      font-weight: 500;
      font-size: 24px;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      vertical-align: middle;
    }
  }

  .content-detail {
    margin: 0 40px;
    padding-bottom: 16px;
    color: #888585;
    font-weight: normal;
    font-size: 24px;
    font-family: PingFangSC;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
  }
  & + .invoice-form-group {
    margin-top: 24px;
  }
}

.input-wrap {
  display: flex;
  align-items: center;
  .icon {
    width: 16px;
    height: 27px;
    margin-left: 14px;
  }
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  // height: 122px;
  width: 100%;
  margin-top: 50px;
  padding: 0 40px;
  background: #fff;
  .button-wrap {
    display: flex;
    justify-content: center;
    padding: 12px 0;
    padding-bottom: calc(12px + constant(safe-area-inset-bottom));
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
  }
}
</style>
